import CONST_STORAGE from 'constants/storage';

export const setHiddenItems = (hiddenItems: boolean) =>
  localStorage.setItem(
    CONST_STORAGE.TRANSPORT_VOUCHERS.HIDDEN_ITEMS,
    `${hiddenItems}`,
  );

export const getHiddenItems = () =>
  localStorage.getItem(CONST_STORAGE.TRANSPORT_VOUCHERS.HIDDEN_ITEMS);

export const removeHiddenItems = () =>
  localStorage.removeItem(CONST_STORAGE.TRANSPORT_VOUCHERS.HIDDEN_ITEMS);
